(() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('[data-rd-gallery]').forEach(gallery => {
      if (gallery.dataset.rdGalleryReady) return;
      gallery.dataset.rdGalleryReady = 'true';
      const slider = gallery.querySelector('[data-product-photos]');
      const thumbs = () => [...gallery.querySelectorAll('.product__thumb-item:not(.hide) [data-product-thumb]')];
      const slides = () => [...slider.querySelectorAll('.product-main-slide:not(.hide)')];
      const counter = gallery.querySelector('[data-rd-gallery-count]');
      const previous = gallery.querySelector('[data-rd-gallery-prev]');
      const next = gallery.querySelector('[data-rd-gallery-next]');
      const ar = document.documentElement.lang.startsWith('ar');
      function update() {
        const items = slides();
        const active = items.findIndex(slide => slide.classList.contains('is-selected'));
        const index = Math.max(0, active);
        const value = `${index + 1} / ${items.length}`;
        if (counter.textContent !== value) counter.textContent = value;
        previous.disabled = next.disabled = items.length < 2;
        thumbs().forEach(thumb => {
          if (thumb.dataset.index === items[index]?.dataset.index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        const video = items[index]?.querySelector('video');
        gallery.querySelector('.rd-gallery-hint').textContent = video ? (ar ? 'شاهدي الفستان أثناء الحركة' : 'See the dress in motion') : (ar ? 'اضغطي على الصورة للتكبير' : 'Tap image to zoom');
      }
      function go(delta) {
        const items = slides();
        const index = Math.max(0, items.findIndex(slide => slide.classList.contains('is-selected')));
        const target = items[(index + delta + items.length) % items.length];
        thumbs().find(thumb => thumb.dataset.index === target?.dataset.index)?.click();
      }
      previous.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      // Let the existing slider own swipe gestures and keep zoom from firing after a drag.
      let pointer, moved = false;
      slider.addEventListener('pointerdown', event => { pointer = {x:event.clientX,y:event.clientY}; moved = false; }, true);
      slider.addEventListener('pointermove', event => { if(pointer && Math.hypot(event.clientX-pointer.x,event.clientY-pointer.y)>10) moved=true; }, true);
      slider.addEventListener('click', event => {
        if (moved || event.target.closest('button,a,video,iframe')) return;
        if (event.target.closest('.photoswipe__image')) event.target.closest('.product-main-slide')?.querySelector('.js-photoswipe__zoom')?.click();
      });
      // Native media stays in the same gallery. The old video CTA now selects that slide.
      gallery.closest('.product-section')?.addEventListener('click', event => {
        if (!event.target.closest('.rd-watch-btn')) return;
        const videoSlide = slides().find(slide => slide.querySelector('video,[data-video-type]'));
        const thumb = thumbs().find(item => item.dataset.index === videoSlide?.dataset.index);
        if (thumb) {
          event.preventDefault();
          event.stopImmediatePropagation();
          thumb.click();
          gallery.scrollIntoView({block:'nearest',behavior:'auto'});
        }
      }, true);
      const observer = new MutationObserver(update);
      observer.observe(slider, {subtree:true,childList:true,attributes:true,attributeFilter:['class']});
      update();
      document.addEventListener('shopify:section:unload', event => { if(event.target.contains(gallery)) observer.disconnect(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('page:loaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
